import { createContext, useContext } from 'react';

import { TradeMethod } from 'types';

type SqPendingMethodContextValue = {
  pendingTradeMethod: TradeMethod | undefined;
  setPendingTradeMethod: (method: TradeMethod | undefined) => void;
};

export const SqPendingMethodContext =
  createContext<SqPendingMethodContextValue>({
    pendingTradeMethod: undefined,
    setPendingTradeMethod: () => {},
  });

export const useSqPendingMethod = () => useContext(SqPendingMethodContext);
